/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/**
 * Media Gallery Component
 * @module patterns/components/media-gallery
 */

import Glide from '@glidejs/glide';

import { App } from '~/app';

import { CLASS_NAME } from '../../carousels/archive/modal-carousel/constants';
import { carousels } from '../../carousels/archive/modal-carousel/modal-carousel';

// Add overlay count value to the last thumbnail in media gallery
const renderMediaItemCount = (mediaGalleryComponent: HTMLElement) => {
    const mediaItemCount = mediaGalleryComponent.querySelector('.media-gallery-count');
    if (mediaItemCount) {
        const imageCount = mediaGalleryComponent.querySelectorAll('.media-gallery-modal .thumbnails img')?.length || 0;
        const imageOverflowCount = imageCount - 4;
        mediaItemCount.innerHTML = imageOverflowCount > 0 ? `+${String(imageOverflowCount)}` : '';
    }
};

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Modal Feature Component');

    const listeners: Array<[Element, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            const mediaGalleryComponents = document.querySelectorAll<HTMLElement>('[data-media-gallery]');

            for (const mediaGalleryComponent of mediaGalleryComponents) {
                // Updates image overflow count on media gallery
                renderMediaItemCount(mediaGalleryComponent);

                const modalId = mediaGalleryComponent.dataset.modalId;
                const mediaGalleryModal = mediaGalleryComponent.querySelector<HTMLElement>('.modal');

                if (mediaGalleryModal) {

                    // Update / render the glide instance
                    const updateGlideInstance = (event: Event) => {
                        const glide = carousels.get(`${CLASS_NAME}-${modalId}`) as Glide;
                        const focusEvent = event as FocusEvent;

                        if (event.type.includes('shown')) {
                            // Set carousel starting value based on the image clicked
                            const targetHtml = focusEvent.relatedTarget as HTMLElement;
                            const startIndex = targetHtml.dataset.goTo ?? "3";
                            glide.update({
                                startAt: Number.parseInt(startIndex),
                            });
                        } else {
                            glide.update();
                        }
                    };

                    mediaGalleryModal.addEventListener('shown.bs.modal', updateGlideInstance);
                    listeners.push([mediaGalleryModal, 'shown.bs.modal', updateGlideInstance]);

                    mediaGalleryModal.addEventListener('hidden.bs.modal', updateGlideInstance);
                    listeners.push([mediaGalleryModal, 'hidden.bs.modal', updateGlideInstance]);
                }
            }
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Media Gallery component', error);
        });

    return function destoryMediaGalleryFeature() {
        for (const [element, event, listener] of listeners) {
            element.removeEventListener(event, listener);
        }

        app.logger.debug('[DXA] Media Gallery component destroyed');
    };
};
